import { motion } from "framer-motion";
import {
  PenTool,
  Smartphone,
  Search,
  Zap,
  MessageSquare,
  MapPin,
} from "lucide-react";
import { SERVICES } from "@/site/content";

const ICONS = { PenTool, Smartphone, Search, Zap, MessageSquare, MapPin };

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-widest text-blue-700 mb-3">
            What's included
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900">
            Everything your business needs to be found, trusted, and called.
          </h2>
          <p className="mt-4 text-gray-600 text-base md:text-lg leading-relaxed">
            One flat package. No upsells, no hidden fees, no jargon.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Zap;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.4, delay: i * 0.04 }}
                className="group rounded-xl border border-gray-200 bg-white p-7 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
                data-testid={`service-card-${i}`}
              >
                <div className="h-11 w-11 rounded-md bg-blue-700/10 text-blue-700 flex items-center justify-center mb-5 group-hover:bg-blue-700 group-hover:text-white transition-colors">
                  <Icon size={20} />
                </div>
                <h3 className="font-display font-bold text-xl text-gray-900">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                  {s.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
